<template>
  <div class="for-transition w-100 flex flex-column gap-medium">
    <div>
      <h4 class="mn-b-small">{{ t('auth.profileEdit.profile.title') }}</h4>
      <div class="card">
        <!-- label: клик по ЛЮБОМУ месту блока активирует file-input внутри
             Upload (нативное поведение label), а не только сам кружок. -->
        <label class="input mn-b-small w-100 flex-center flex-column flex gap-small pd-medium cursor-pointer">
          <Upload
            v-model:value="users.state.current.profile.photo"
            :uploadPath="'users/' + users.state.current._id + '/avatars'"
            class="h-8r w-8r aspect-1x1 o-hidden bg-base radius-extra"
          />
          <p class="p-small t-muted">{{ t('auth.profileEdit.profile.uploadUserpic') }}</p>
        </label>

        <Field
          v-model:field="users.state.current.username"
          label="@"
          :placeholder="t('auth.profileEdit.profile.notSpecified')"
          class="mn-b-thin w-100 input input--l"
          :validation="organizationName"
        />

        <p class="p-small t-muted mn-b-regular">{{ t('auth.profileEdit.profile.usernameHint') }}</p>

        <Field
          v-model:field="users.state.current.profile.name"
          :label="t('auth.profileEdit.profile.name')"
          :placeholder="t('auth.profileEdit.profile.notSpecified')"
          class="mn-b-thin input input--l"
          :validation="organizationName"
        />

        <Field
          v-model:field="users.state.current.profile.description"
          :label="t('auth.profileEdit.profile.description')"
          :placeholder="t('auth.profileEdit.profile.notSpecified')"
          class="input input--l"
          :validation="organizationName"
        />
      </div>
    </div>

    <div>
      <h4 class="mn-b-small">{{ t('auth.profileEdit.profile.socialsTitle') }}</h4>
      <div class="card">
        <p class="p-small t-muted mn-b-regular">{{ t('auth.profileEdit.profile.socialsHint') }}</p>

        <Field
          v-model:field="users.state.current.socials.instagram"
          label="Instagram"
          placeholder=""
          class="mn-b-thin input input--l"
        />
        <Field
          v-model:field="users.state.current.socials.twitter"
          label="Twitter"
          placeholder=""
          class="mn-b-thin input input--l"
        />
        <Field
          v-model:field="users.state.current.socials.facebook"
          label="Facebook"
          placeholder=""
          class="mn-b-thin input input--l"
        />
        <Field
          v-model:field="users.state.current.socials.telegram"
          label="Telegram"
          placeholder=""
          class="input input--l"
        />
      </div>
    </div>

    <Button
      :submit="onSubmit"
      :callback="redirectTo"
      class="button--accent button--l w-100"
    >
      {{ t('auth.profileEdit.profile.save') }}
    </Button>
  </div>
</template>

<script setup>
  import Field from '@martyrs/src/design-system/components/Field/Field.vue'
  import Button from '@martyrs/src/design-system/components/Button/Button.vue'
  import Upload from '@martyrs/src/design-system/components/Upload/Upload.vue'

  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'

  import * as auth from '@martyrs/src/modules/auth/views/store/auth.js'
  import * as users from '@martyrs/src/modules/auth/views/store/users.js'

  const router = useRouter()
  const { t } = useI18n()

  defineProps({
    userData: {
      type: Object,
      required: true
    }
  })

  async function onSubmit() {
    await users.actions.update(users.state.current)
  }

  function redirectTo() {
    router.back()
  }
</script>
